import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Star, MessageSquareQuote } from 'lucide-react';
interface Review {
  stars: number;
  text: string;
  name: string;
  location: string;
  detail: string;
  followers?: string;
}
export function Testimonials() {
  const reviews: Review[] = [{
    stars: 5,
    text: 'Llevaba 8 meses en mi empresa y ya había quemado mi lista completa. Mis amigos me ignoraban y mi familia cambiaba el tema cuando me veían. Compré el plan sin muchas expectativas. El Día 1 me pareció sencillo pero lógico. El Día 4, literalmente el Día 4, una chica que me seguía en Instagram desde hacía semanas me escribió preguntando de qué trataba mi proyecto. Eso nunca me había pasado en 8 meses de mensajes en frío.',
    name: 'Carolina M.',
    location: 'Venezuela',
    detail: 'Networker en empresa de bienestar · 312 seguidores cuando empezó el plan'
  }, {
    stars: 5,
    text: 'Mi problema no era yo, era que no tenía cómo enseñarle a mi equipo nuevo a prospectar sin molestar a su entorno. Cuando vi el plan de 7 días entendí que era exactamente lo que necesitaba para duplicar mi sistema. Ahora cada nuevo socio que entra hace los 7 días primero antes de hablarle a cualquier persona. Los resultados de duplicación cambiaron por completo.',
    name: 'Roberto A.',
    location: 'México',
    detail: 'Líder de equipo de 34 personas'
  }, {
    stars: 5,
    text: 'Tengo empleo de tiempo completo y dos hijos. No tenía tiempo para un curso de 30 módulos. Lo que me convenció fue exactamente eso: 45 minutos por día y una tarea clara. Para el Día 6 ya tenía 3 conversaciones abiertas con personas que me habían encontrado por mi contenido. Nunca les escribí primero. Ellos llegaron solos.',
    name: 'Daniela F.',
    location: 'España',
    detail: 'Networker part-time con empleo en administración'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-dark px-6 py-20 md:py-28 border-t border-slate-800" data-id="element-270">
      <div className="mx-auto max-w-3xl" data-id="element-271">
        <div className="text-center mb-12" data-id="element-272">
          <div className="inline-flex items-center justify-center p-3 bg-brand-light rounded-full mb-4 border border-slate-700" data-id="element-273">
            <MessageSquareQuote className="w-8 h-8 text-brand-gold" data-id="element-274" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-275">
            Lo que Dicen los Networkers que ya Activaron su Sistema
          </h2>
        </div>

        <div className="space-y-4" data-id="element-276">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.12
        }} className="bg-brand-light border border-slate-800 rounded-xl overflow-hidden" data-id="element-277">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-278">
                <div className="flex items-center gap-3 pr-4" data-id="element-279">
                  <div className="flex gap-0.5" data-id="element-280">
                    {Array.from({
                  length: review.stars
                }).map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-281" />)}
                  </div>
                  <span className="text-lg font-semibold text-white" data-id="element-282">
                    {review.name}
                  </span>
                  <span className="text-sm text-slate-500 hidden sm:inline" data-id="element-283">
                    — {review.location}
                  </span>
                </div>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-284" />
              </button>

              <AnimatePresence data-id="element-285">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-286">
                    <div className="px-6 pb-6 border-t border-slate-800/50 pt-4" data-id="element-287">
                      <p className="text-slate-300 leading-relaxed italic mb-4" data-id="element-288">
                        "{review.text}"
                      </p>
                      <div className="flex flex-col gap-1" data-id="element-289">
                        <span className="text-sm text-brand-gold font-medium" data-id="element-290">
                          — {review.name} · {review.location}
                        </span>
                        <span className="text-xs text-slate-500" data-id="element-291">
                          {review.detail}
                        </span>
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}